import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";

function getUnavailableContent(pausedUntil?: string | null) {
  if (!pausedUntil) {
    return {
      title: "This product is currently unavailable.",
      description:
        "This could be due to the kitchen being closed or the product being out of stock.\n\nPlease try again later.",
    };
  }

  const pausedDate = new Date(pausedUntil);
  const now = new Date();
  const diffInMinutes = (pausedDate.getTime() - now.getTime()) / (1000 * 60);

  if (diffInMinutes < 30) {
    return {
      title: "This product is temporarily unavailable.",
      description:
        "This item will be available again soon.\n\nYou can check back in a few minutes, or go to the counter.",
    };
  }

  return {
    title: "This product is out of stock.",
    description:
      "This item is currently out of stock for today.\n\nPlease come back tomorrow to try again.",
  };
}

export default function UnavailableProduct({
  isOpen,
  setIsOpen,
  type = "unavailable",
  pausedUntil,
}: {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  type?: "unavailable" | "counter_only";
  pausedUntil?: string | null;
}) {
  const content =
    type === "counter_only"
      ? {
          title: "Please order this at the kitchen counter",
          description:
            "This item isn't available for table service, please make your way to the kitchen counter to order",
        }
      : getUnavailableContent(pausedUntil);

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <div className="flex flex-col gap-y-2">
          <p className="whitespace-pre-line">{content.title}</p>

          <p className="whitespace-pre-line text-xs text-muted-foreground text-left">
            {content.description}
          </p>
        </div>
        <AlertDialogFooter>
          <AlertDialogAction
            className="bg-primary"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
